import styles from "./FoodShowcaseComponent.module.css";

export default function FoodShowcaseComponent() {
	return (
		<>
			<div className={styles.project}>
				<div>
					<h1 className={styles.name}>Food Blog Showcase</h1>
					<h3>
						Skills used: React, Next.js, TypeScript, Prisma ORM,
						Next-Auth, Next-Intl
					</h3>
					<h3>Database: MongoDB, Supabase</h3>
					<h3>APIs: Gemini</h3>
				</div>
				<div>
					<h1 className={styles.name}>Overview</h1>
					<p>
						A site where users can upload blog posts and interact
						with other user's post. Users can login using their
						gmail to see their posts and comment on others. The site
						uses mongodb to store text content and supabase to allow
						users to upload a food image to their post. The site
						also uses the gemini API where users can pass in their
						current posts to be rewritten/expanded on. The site
						supports search allowing users to find post through key
						words.
					</p>
					<a
						className={styles.button}
						href="https://github.com/benwesson/ben_blog_layout"
					>
						See GitHub
					</a>
				</div>
				<div>
					<h1 className={styles.name}>Home</h1>
					<p>
						The Home page dispalys the week's featured recipe at the
						top of the page followed by a grid of recent recipes.
						The featured recipe tile shows the recipe title, author
						of the post, the category it was tagged as (Breakfast,
						Lunch, Dinner, Snack), and a brief description of the
						recipe which is 250 character slice taken from the post
						content. There is also a recipe button that links to a
						dedicated page for that recipe. The featured recipe is
						selceted as the most recent post fetched from the
						database. Below featured is a set of catorgy tiles that
						take you to a page with only recipes from that category.
						Below that is a grid of recent recipes that follow
						feature the same format as the featured recipe and also
						link to deicated pages.
					</p>
				</div>
				<div>
					<h1 className={styles.name}>Recipes</h1>
					<p>
						The recipe page allows users to view a dedicated page
						where users can select a catorgy of recipes to view.
						When you select a category the project used a next.js
						dynamic route to fetch the recipes from the database
						that match that category. Each recipe is displayed in a
						card format showing the title, author, brief
						description, and a link to the dedicated recipe page.
					</p>
				</div>
				<div>
					<h1 className={styles.name}>Post</h1>
					<p>
						The post page allows users to create posts. Users can
						create a post with a title, content, category tag, and
						upload an image to go along with the post. The image is
						uploaded to supabase storage and the post data is stored
						in mongodb. The post page is an authenticated route so
						only logged in users can create posts. Once logged in
						users can also comment on other user's posts. Comments
						are viewable on the page for that specific post.
					</p>
				</div>

				<div>
					<h1 className={styles.name}>Login</h1>
					<p>
						The login page allows users to securely login using
						their gmail account. Next-Auth is used to handle the
						oauth process and session managment. It works seamlessly
						with the Prisam ORM adapter to assocate users with their
						portfolio in my database.
					</p>
				</div>
			</div>
		</>
	);
}
